import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57156998"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "shop-finally"
}
const _hoisted_2 = { class: "shop-finally__wrap" }
const _hoisted_3 = { class: "shop-finally__kind" }
const _hoisted_4 = { class: "shop-form__block" }
const _hoisted_5 = { class: "shop-form__block" }
const _hoisted_6 = { class: "shop-form__block" }
const _hoisted_7 = { class: "shop-form__block" }
const _hoisted_8 = { class: "shop-form__block" }

import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import getExpirationStringForCertificate from "@/functions/getExpirationStringForCertificate";
import getExpirationStringForAbonement from "@/functions/getExpirationStringForAbonement";


export default /*#__PURE__*/_defineComponent({
  __name: 'shop-finally',
  setup(__props) {

const store = useStore();

const route = useRoute();

const currentPagePayment = computed(() => store.state.currentPagePayment);

const currentDesing = computed(() => store.state.allDesignTypes.find(i => i.id === currentPagePayment.value.design_id))

const expirationStr = computed(() => {
  if (currentPagePayment.value.type === "certificate") {
    return getExpirationStringForCertificate(currentPagePayment.value.currentLoyality)
  } else {
    return getExpirationStringForAbonement(currentPagePayment.value.currentLoyality)
  }
})

const parseLoyalityName = computed(() => {
  if (currentPagePayment.value.type === "certificate") {
    const cells: {
      first: "Номинал" | string | null;
      second: number | string | null;
    } = {
      first: null,
      second: null,
    };
    const title = currentPagePayment.value.currentLoyality.title;

    const isNominal = title.split("/")[0].trim() === "Номинал";

    if (isNominal) {
      cells.first = "Номинал";
      cells.second = currentPagePayment.value.currentLoyality.balance + ' ₽';
    }

    return cells;
  } else {
    return "";
  }
});

const titleStr = computed(() => {
  return currentPagePayment.value.currentLoyality.title.replace(/\//g, '|');
})

return (_ctx: any,_cache: any) => {
  return (currentPagePayment.value.type)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "shop-finally__img",
          style: _normalizeStyle({
        background: `url(${ currentDesing.value.image}) no-repeat center / cover`,
      })
        }, null, 4),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(currentPagePayment.value.type === "certificate" ? "СЕРТИФИКАТ" : "АБОНЕМЕНТ"), 1),
          _createElementVNode("div", _hoisted_4, " № " + _toDisplayString(currentPagePayment.value.type === "certificate" ? currentPagePayment.value.certificate_number : currentPagePayment.value.abonement_number), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(currentPagePayment.value.Data.Name), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString((currentPagePayment.value.Amount.split(".")[0] / 100).toLocaleString()) + " ₽ ", 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(titleStr.value), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", null, _toDisplayString(expirationStr.value) + ".", 1),
            _createElementVNode("p", null, " Для использования " + _toDisplayString(currentPagePayment.value.type === "certificate" ? "сертификата" : "абонемента") + " нужен номер, который на нем указан (или указан в сообщении). ", 1),
            _createElementVNode("p", null, _toDisplayString(currentPagePayment.value.type === "certificate" ? "Сертификат" : "Абонемент") + " распространяется на все услуги и товары представленные в студии (в том числе абонементы). ", 1),
            _createElementVNode("p", null, _toDisplayString(currentPagePayment.value.type === "certificate" ? "Сертификат" : "Абонемент") + " можно использовать как полностью, так и частично в течении нескольких посещений. ", 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})